import { createDialogContextBundle } from "src/components/Dialog";
import { UpdateEligibilityDialogProps } from "./types";

export const {
  DialogContext: UpdateEligibilityDialogContext,
  useDialogContext: useUpdateEligibilityDialogContext,
} = createDialogContextBundle<UpdateEligibilityDialogProps>();
